import type { AsyncIntegration } from './types/asyncIntegration';
import type { Integration } from './types/integration';
import type { IntegrationResolver, ResolveIntegration } from './types/integrationResolver';

export const defineAsyncIntegration = <
  C extends string,
  R extends IntegrationResolver<I>,
  I extends Integration<C, any>,
>(
  code: C,
  resolver: R,
): AsyncIntegration<ResolveIntegration<R>> => {
  let currentResolver: Promise<I> | undefined = undefined;

  return {
    code,
    resolved: false,
    resolver: async () => {
      if (currentResolver !== undefined) {
        return currentResolver;
      }

      return (currentResolver = (async () => (await resolver()).default)());
    },
  };
};
